import {FormError} from "@/components/ui/forms/FormError";

import React from "react";

import {ControlButton} from "@ui/buttons/ControlButton";
import {EditInput} from "@ui/inputs/EditInput";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

export const EditTitle = ({
  value,
  onChange,
  placeholder,
  label,
  error,
  handleClickSave,
  disabledButton,
}) => {
  const {isMobile} = useSelector((state) => state.common.settings);
  const {t} = useTranslation();

  return (
    <div className={styles.editTitle}>
      <div className={"relative"}>
        {error && (
          <FormError
            error={error}
            bottom={-20}
          />
        )}

        <EditInput
          width={!isMobile ? 600 : 210}
          placeholder={placeholder}
          label={label}
          type={"text"}
          value={value}
          onChange={onChange}
        />
      </div>

      <ControlButton
        disabled={disabledButton}
        color={"var(--green)"}
        txt={t("button.save")}
        onClick={() => handleClickSave()}
      />
    </div>
  );
};
